import { api } from '../../axios.instance';

export interface RowImportError {
  row: number;
  column?: string;
  /** Name from the offending row, so the user can find the record in the file. */
  staffName?: string;
  /** The offending cell value, echoed back verbatim. */
  value?: string;
  message: string;
}

export type SavedRowAction = 'created' | 'updated' | 'unchanged';

export interface RowImportSaved {
  row: number;
  staffName: string;
  action: SavedRowAction;
  /** Caveat on an otherwise successful row, e.g. the staff member is discharged. */
  note?: string;
}

export interface ImportStaffResult {
  imported: number;
  skipped: number;
  errors: RowImportError[];
  /** Rows that passed validation, with what was done to each. */
  saved: RowImportSaved[];
  /** Things to know about an otherwise successful import, e.g. wage columns that were ignored. */
  warnings?: string[];
}

export const importStaff = (file: File, facilityId: number) => {
  const formData = new FormData();
  formData.append('file', file);

  return api.post<ImportStaffResult>(
    `/staff/import?facilityId=${facilityId}`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  );
};
